var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contribution-event-base',{attrs:{"event":_vm.event,"variant":_vm.variant,"message":_vm.$options.i18n.message,"icon-name":"approval-solid"}})
}
var staticRenderFns = []

export { render, staticRenderFns }